import React from 'react';
import './DataModal.css';
import Button from '../../formInputs/button/Button';

const WaitingModalBody = ({ message }) => (
    <div className='py-3 text-center'>
        <div className='spinner-border text-primary-900' role='status'></div>

        <p className='text-neutral-700 font-h3 mt-2 mb-1'>
            Please wait and do not refresh the page.
        </p>
        <p className='text-neutral-700 font-h3 mb-0'>{message}</p>
    </div>
);

const DefaultModalBody = (props) => (
    <div className='modal-content ' style={{ maxWidth: '100%', margin: '0 auto' }}>
        <p className='text-end mb-0'>
            <span className='sf-close pe-2 cursor font-h1 float-end' onClick={props.hideModal}></span>
        </p>
        <div className='col-12 px-4 mt-2'>
            <p className='text-neutral-900 font-h1 font-bold text-start'>{props.title}</p>
            <p className='text-neutral-900 font-b3 text-start w-75'>{props.description}</p>
        </div>
        {props.children}
        {!props.isFormValidation ? (
            <div className='mt-4 text-start px-4'>
                <Button type={props.buttonType} onClick={props.onClick}>
                    {props.buttonTitle}
                </Button>
                {props.actions === 'two' && (
                    <>
                        <span className='px-2'></span>
                        <Button type={props.buttonType2} onClick={props.onClick2}>
                            {props.buttonTitle2}
                        </Button>
                    </>
                )}
            </div>
        ) : null}
    </div>
);

const getModalBody = (props) => {
    if (props.modalType === 'apiUpdateModal') {
        return <WaitingModalBody message='It will take few seconds to update the transaction.' />;
    }
    if (props.modalType === 'dealConfirmMOdal') {
        return <WaitingModalBody message='It will take few seconds to accept the bid.' />;
    }
    if (props.modalType === 'requestApproval') {
        return <WaitingModalBody message='Your Request is getting approved.' />;
    }
    if (props.modalType === 'requestFinancing') {
        return <WaitingModalBody message='Your request is being submitted.' />;
    }
    return <DefaultModalBody {...props} />;
};

const DataModal = (props) => {
    let type = props.type;
    let classes;
    switch (type) {
        case 'dataModal-sm':
            classes = 'bg-white dataModal dataModal-sm';
            break;
        case 'dataModal-md':
            classes = 'bg-white dataModal dataModal-md';
            break;
        case 'dataModal-lg':
            classes = 'bg-white dataModal dataModal-lg';
            break;
        case 'dataModal-xl':
            classes = 'bg-white dataModal dataModal-xl';
            break;
        default:
            classes = 'bg-white dataModal';
    }
    return (
        <div className='col-12 custom-modal'>
            <div className='d-flex justify-content-center align-items-center vh-100'>
                <div className={classes}>{getModalBody(props)}</div>
            </div>
        </div>
    );
};

export default DataModal;
